import { QRulePair } from "@coreapp/CoreApp/QRulePair";

export const containerTypesEnum = {
  groupFramed: 300,
  groupHeader: 303,
  nameOnly: 118
};

export const groupSchema = {
  name: null,
  logicalop: "",
  pairs: [],
  type: "Basic Rule",
  conditionalEnabled: false,
  actions: {
    grouping: {
      fApplyToManagers: false,
      fChildrenBoxStyle: null,
      fChildrenBoxStyleEnabled: false,
      fGroupingBoxStyle: containerTypesEnum.groupFramed,
      fGroupingField: null,
      fGroupingFieldEnabled: true,
      fGroupingThreshold: 2,
      fManagerGroupingStyle: "comgr",
      fManagerGroupingBoxStyle: null,
      fManagerChildrenBoxStyle: null,
      fManagerChildrenBoxStyleEnabled: false
    }
  }
};

export const getValidGroupId = groups => {
  let newId = 0;
  while (groups.some(group => group.id === newId)) {
    newId++;
  }
  return newId;
};

export const getGroupById = (groups, id) => {
  return groups.find(group => group.id === id);
};

export const getGroupIndexById = (groups, id) => {
  return groups.findIndex(group => group.id === id);
};

export const ValidGroupName = (groups, name) => {
  return !groups.some(group => group.name === name);
};

export const ValidGroupField = group => {
  return group.actions.grouping.fGroupingField !== null;
};

export const SetActiveGroup = (user, groupID) => {
  localStorage.setItem("activeGroup", JSON.stringify({ user: user, activeGroupID: groupID }));
};
